module.exports = __webpack_public_path__ + "static/media/dolar-avatar.e3be17ae.svg";